import { yomiriP2P } from './YomiriP2PBridge.ts';
import type { YomiriExtension } from '../types/extension.ts';
import type { RepositoryEntry } from '../repositories/RepositoryStore.ts';
export interface CastSource {
  id:string;name:string;lang:string;baseUrl:string;iconUrl:string;version:string;
}
export interface CastSnapshot {
  version:1;
  repositories:{url:string;name:string}[];
  manga:CastSource[];
  anime:string[];
  live:string[];
  entries?:RepositoryEntry[];
}
let snapshot:CastSnapshot|null=null;
export function getRemoteSnapshot(){return yomiriP2P.getRole()==='tv'&&yomiriP2P.getState()==='connected'?snapshot:null;}
export const isRemoteReceiver=()=>!!getRemoteSnapshot();
export function setRemoteSnapshot(value:CastSnapshot|null){
  if(value && (value.version!==1||!Array.isArray(value.repositories)||!Array.isArray(value.manga)||!Array.isArray(value.anime)||!Array.isArray(value.live)||
    value.repositories.length>100||value.manga.length>500||value.anime.length>100||value.live.length>100))throw new Error('Estado del móvil inválido.');
  if(value && value.manga.some(source=>typeof source.id!=='string'||typeof source.name!=='string'||source.name.length>200))throw new Error('Fuente del móvil inválida.');
  snapshot=value;
  window.dispatchEvent(new Event('yomiri-transport-changed'));
  window.dispatchEvent(new Event('yomiri-sources-changed'));
  window.dispatchEvent(new Event('yomiri-cast-state-changed'));
  window.dispatchEvent(new Event('yomiri-library-changed'));
}
export function remoteCall<T>(method:string,args:unknown):Promise<T>{return yomiriP2P.request<T>(method,args);}
export function remoteMangaExtensions():YomiriExtension[]{
  return (getRemoteSnapshot()?.manga||[]).map(source=>({
    ...source, website:source.baseUrl, nsfw:false,
    search:(query,page=1,filters)=>remoteCall('manga.search',{sourceId:source.id,args:[query,page,filters]}),
    getPopular:(page=1)=>remoteCall('manga.popular',{sourceId:source.id,args:[page]}),
    getLatest:(page=1)=>remoteCall('manga.latest',{sourceId:source.id,args:[page]}),
    getManga:id=>remoteCall('manga.detail',{sourceId:source.id,args:[id]}),
    getChapters:(id,options)=>remoteCall('manga.chapters',{sourceId:source.id,args:[id,options]}),
    getPages:async id=>(await remoteCall<import('../types/extension.ts').YomiriPage[]>('manga.pages',{sourceId:source.id,args:[id]})).map(page=>({...page,sourceId:source.id})),
    getSearchFilters:()=>remoteCall('manga.filters',{sourceId:source.id,args:[]}),
  } as YomiriExtension));
}
